module.exports = __webpack_public_path__ + "static/img/application14-1.dafc416.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application14-1.jpg
// module id = KX+y
// module chunks = 0